export default __webpack_public_path__ + "static/media/appDesktopBanner.e459f698.webp";